/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Tag_Filter_ClearInputs */



/**
* | output |
* | --- |
* | "Clear" |
*
* @param {Projects_Tag_Filter_ClearInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const projects_tag_filter_clear = /** @type {((inputs?: Projects_Tag_Filter_ClearInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Tag_Filter_ClearInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zurücksetzen")
	return /** @type {LocalizedString} */ ("Clear")
});